export const DESKTOP_VISIBLE_COUNT = 8;
export const MOBILE_VISIBLE_COUNT = 5;
export const ANIMATION_STAGGER_MS = 50;
